export enum ExperienceName {
  BBQ = 'BARBECUE',
  BROKERAGE_COMPANION = 'BROKERAGE_COMPANION',
  TERIYAKI = 'TERIYAKI',
}
